import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';

import InvoicesComponent from '@app/components/ManageInvoices/list';

const ManageInvoices: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>Manage Invoices</PageTitle>
      <InvoicesComponent />
    </>
  );
};

export default ManageInvoices;
